import { connect } from "react-redux";
import Header from "../../Components/Header/Header";

import { setActiveTenant } from "../../Redux/Actions/activeTenantActions";
const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    partnerTenants: state.reducer.partnerTenants,
  });
const mapDispatchToProps = (dispatch) => ({
      setActiveTenant: (ACTIVE_TENANT) => dispatch(setActiveTenant(ACTIVE_TENANT)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(Header);